import { Button, Slider, withStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import FeaturesCss from "./style";
import web3_obj from "../../getWeb3.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

const ModSlider = withStyles({
  root: {
    color: "#FDCD0B",
    height: 2,
    width: "25vw",
    padding: "15px 0",
    "@media(max-width:700px)": {
      width: "25vw",
    },
    "@media(max-width:500px)": {
      width: "70vw",
      marginTop: "-2rem",
    },
  },
  thumb: {
    width: "24px",
    height: "24px",
    top: "12px",
    "@media(max-width:600px)": {
      width: "20px",
      height: "20px",
      top: "14px",
      border: "2px solid #444B58",
    },
    "@media(max-width:400px)": {
      width: "16px",
      height: "16px",
      border: "2px solid #444B58",
      top: "14px",
    },
    background: "#1D2738",
    border: "3px solid #444B58",
    boxShadow:
      "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)",
    borderRadius: "50%",
    "&:focus, &:hover, &:active": {
      boxShadow:
        "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)",
      // color: "#1D2738",

      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow:
          "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)",
      },
    },
  },
  active: {
    // color: "#1D2738"
  },
  valueLabel: {
    // left: "calc(-50% + 12px)",
    // top: -22,
    "& *": {
      transform: "scale(1.2)",
      // width: "70px",
      // height: "70px",
      marginLeft: "4px",
      marginTop: "4px",
      // fontSize: "20px",
      fontWeight: "550",
      // paddingRight: "3px",
      // paddingTop: "2px",
      // background: "#FDCD0B",
      background: "transparent",
      // color: "#1D2738",
      color: "#fdcd0b",
      "@media(max-width:600px)": {
        marginLeft: "6px",
      },
      "@media(max-width:400px)": {
        marginLeft: "3px",
        fontSize: "11px",
      },
    },
  },
  track: {
    height: "11px",
    borderRadius: "50px",
    "@media(max-width:600px)": {
      height: "8px",
    },
    "@media(max-width:400px)": {
      height: "6px",
    },
  },
  rail: {
    height: "11px",
    borderRadius: "50px",
    backgroundColor: "white",
    opacity: "0.3",
    "@media(max-width:600px)": {
      height: "10px",
    },
    "@media(max-width:400px)": {
      height: "6px",
    },
  },
  mark: {
    display: "none",
  },
  markLabel: {
    color: "#fff",

    fontFamily: "Poppins",
    fontSize: "18px",
    fontWeight: "300",
    marginTop: "10px",
    "@media(max-width:1000px)": {
      fontSize: "14px",
      marginTop: "3px",
    },
    "@media(max-width:600px)": {
      fontSize: "10px",
      // marginTop: "-2px"
    },
    "@media(max-width:400px)": {
      fontSize: "8px",
      marginTop: "-5px",
    },
  },
  markLabelActive: {
    color: "#FDCD0B",
  },
  markActive: {
    opacity: 1,
    backgroundColor: "currentColor",
  },
})(Slider);

const marks = [
  {
    value: 0.1,
    label: "0.1 BNB",
  },
  {
    value: 10,
    label: "10.00 BNB",
  },
];

const Features = props => {
  const [timer, setTimer] = useState();
  const [timer2, setTimer2] = useState();
  const [live, setLive] = useState(false);
  const [val, setVal] = useState(5.0);
  const [productionAcc] = useState(
    "0x3e4a42F2CCC77CBF284C377079829C0c8047e64e"
  );
  const [txnLoading, setTxnLoading] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const [statusCode, setStatusCode] = useState(0);

  useEffect(() => {
    const start_timestamp = 1622723400;
    const end_timestamp = 1625572800;
    web3_obj && web3_obj.init();

    var x = setInterval(function () {
      // Get today's date and time
      const currentDate = new Date();
      const now = parseInt(currentDate.getTime().toString().slice(0, -3));

      // Find the distance between now and the count down date
      var distance = start_timestamp - now;
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (60 * 60 * 24));
      var hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60));
      var minutes = Math.floor((distance % (60 * 60)) / 60);
      var seconds = Math.floor(distance % 60);

      // Display the result in the element with id="demo"
      setTimer({
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
      });

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        setTimer();
        setLive(true);
      }
    }, 1000);
    var y = setInterval(function () {
      // Get today's date and time
      const currentDate = new Date();
      const now2 = parseInt(currentDate.getTime().toString().slice(0, -3));

      // Find the distance between now and the count down date
      var distance2 = end_timestamp - now2;
      // Time calculations for days, hours, minutes and seconds
      var days2 = Math.floor(distance2 / (60 * 60 * 24));
      var hours2 = Math.floor((distance2 % (60 * 60 * 24)) / (60 * 60));
      var minutes2 = Math.floor((distance2 % (60 * 60)) / 60);
      var seconds2 = Math.floor(distance2 % 60);

      // Display the result in the element with id="demo"
      setTimer2({
        days: days2,
        hours: hours2,
        minutes: minutes2,
        seconds: seconds2,
      });

      // If the count down is finished, write some text
      if (distance2 < 0) {
        clearInterval(y);
        setTimer2();
        setLive(false);
      }
    }, 1000);
    console.log(props);
  }, []);

  const bnbTransfer = async () => {
    if (
      web3_obj.web3_instance &&
      web3_obj.accounts[0][0] &&
      (web3_obj.networkId === 56 || web3_obj.networkId === 97)
    ) {
      try {
        setTxnLoading(true);

        await web3_obj.web3_instance.eth.sendTransaction({
          to: productionAcc,
          from: web3_obj.accounts[0][0],
          value: val * 1e18,
          gas: 40000,
        });
        setTimeout(() => {
          setTxnLoading(false);
          setStatusCode(200);
          setToastOpen(true);
        }, 1000);
      } catch (err) {
        console.log("err");
        setTxnLoading(false);
        setStatusCode(500);
        setToastOpen(false);
      }
    } else {
      console.log("not connected");
      setTxnLoading(false);
    }
  };
  const isDisabled = () => {
    if (
      web3_obj &&
      web3_obj.accounts[0] &&
      web3_obj.accounts[0][0] &&
      (web3_obj.networkId === 56 || web3_obj.networkId === 97)
    ) {
      return false;
    } else {
      return true;
    }
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setToastOpen(false);
  };
  const handleSliderChange = (event, newValue) => {
    setVal(newValue);
    console.log(newValue);
  };
  return (
    <FeaturesCss>
      <div className="wrapper" id="features">
        <div className="header">
          The <b>DeFi token</b> that does it <b>ALL</b>.
        </div>
        <div className="features_div1">
          <div className="feature">
            <div className="f_img">
              <img src="/features/1.png" alt="1st" />
            </div>
            <div className="f_text">Autonomous Yield</div>
          </div>
          <div className="feature">
            <div className="f_img">
              <img src="/features/2.png" alt="1st" />
            </div>
            <div className="f_text">Continuous Liquidity</div>
          </div>
          <div className="feature">
            <div className="f_img">
              <img src="/features/3.png" alt="1st" />
            </div>
            <div className="f_text">Monthly Airdrop</div>
          </div>
          <div className="feature" style={{ border: "none" }}>
            <div className="f_img">
              <img src="/features/4.png" alt="1st" />
            </div>
            <div className="f_text">Locked Liquidity</div>
          </div>
        </div>
        <div className="features_div1_tab">
          <div className="feature">
            <div className="f_img">
              <img src="/features/1.png" alt="1st" />
            </div>
            <div className="f_text">Autonomous Yield</div>
          </div>
          <div className="feature">
            <div className="f_img">
              <img src="/features/2.png" alt="1st" />
            </div>
            <div className="f_text">Continuous Liquidity</div>
          </div>
          <div className="feature" style={{ border: "none" }}>
            <div className="f_img">
              <img src="/features/3.png" alt="1st" />
            </div>
            <div className="f_text">Monthly Airdrop</div>
          </div>
        </div>
        <div className="features_div2">
          <div className="feature">
            <div className="f_img">
              <img src="/features/5.png" alt="1st" />
            </div>
            <div className="f_text">Deflationary by Nature</div>
          </div>
          <div className="feature">
            <div className="f_img">
              <img src="/features/6.png" alt="1st" />
            </div>
            <div className="f_text">Farming (of course)</div>
          </div>
          <div className="feature" style={{ border: "none" }}>
            <div className="f_img">
              <img src="/features/7.png" alt="1st" />
            </div>
            <div className="f_text">79% Ownership Renounced</div>
          </div>
        </div>
        <div className="features_div2_tab">
          <div className="feature">
            <div className="f_img">
              <img src="/features/4.png" alt="1st" />
            </div>
            <div className="f_text">Locked Liquidity</div>
          </div>
          <div className="feature" style={{ border: "none" }}>
            <div className="f_img">
              <img src="/features/5.png" alt="1st" />
            </div>
            <div className="f_text">Deflationary by Nature</div>
          </div>
        </div>
        <div className="features_div2_tab">
          <div className="feature">
            <div className="f_img">
              <img src="/features/6.png" alt="1st" />
            </div>
            <div className="f_text">Farming (of course)</div>
          </div>
          <div className="feature" style={{ border: "none" }}>
            <div className="f_img">
              <img src="/features/7.png" alt="1st" />
            </div>
            <div className="f_text">79% Ownership Renounced</div>
          </div>
        </div>
        <div className="features_div_mob">
          <div className="feature">
            <div className="f_img">
              <img src="/features/1.png" alt="1st" />
            </div>
            <div className="f_text">Autonomous Yield</div>
          </div>
          <div className="feature" style={{ border: "none" }}>
            <div className="f_img">
              <img src="/features/2.png" alt="1st" />
            </div>
            <div className="f_text">Continuous Liquidity</div>
          </div>
          <div className="feature">
            <div className="f_img">
              <img src="/features/3.png" alt="1st" />
            </div>
            <div className="f_text">Monthly Airdrop</div>
          </div>
          <div className="feature" style={{ border: "none" }}>
            <div className="f_img">
              <img src="/features/4.png" alt="1st" />
            </div>
            <div className="f_text">Locked Liquidity</div>
          </div>
          <div className="feature">
            <div className="f_img">
              <img src="/features/5.png" alt="1st" />
            </div>
            <div className="f_text">Deflationary by Nature</div>
          </div>
          <div className="feature" style={{ border: "none" }}>
            <div className="f_img">
              <img src="/features/6.png" alt="1st" />
            </div>
            <div className="f_text">Farming (of course)</div>
          </div>
          <div className="feature" style={{ border: "none" }}>
            <div className="f_img">
              <img src="/features/7.png" alt="1st" />
            </div>
            <div className="f_text">79% Ownership Renounced</div>
          </div>
        </div>
        {(timer2 || timer) && (
          <div className="header2" id="participate">
            {props.match.path === "/" ? (
              <span>
                Please Join Our{" "}
                <a href="/bounce" className="highlight">
                  CEFA Initial DEX Offering
                </a>
              </span>
            ) : (
              "Participate in our 1000 BNB Private Sale"
            )}
          </div>
        )}
        {props.match.path !== "/" && timer && (
          <div className={live ? "none" : "time"}>
            <div className="ends"> Starts in &nbsp;</div>
            <span className="timer">
              <span>
                {" "}
                {timer &&
                  (timer.days < 10
                    ? String(timer.days).padStart(2, "0")
                    : timer.days)}{" "}
                <sub className="unit">D</sub>
              </span>

              <span>
                {timer &&
                  (timer.hours < 10
                    ? String(timer.hours).padStart(2, "0")
                    : timer.hours)}{" "}
                <sub className="unit">H</sub>
              </span>

              <span>
                {timer &&
                  (timer.minutes < 10
                    ? String(timer.minutes).padStart(2, "0")
                    : timer.minutes)}
                <sub className="unit" style={{ marginLeft: "5px" }}>
                  M
                </sub>
              </span>
              <span>
                {timer &&
                  (timer.seconds < 10
                    ? String(timer.seconds).padStart(2, "0")
                    : timer.seconds)}
                <sub className="unit" style={{ marginLeft: "5px" }}>
                  S
                </sub>
              </span>
            </span>
          </div>
        )}
        {props.match.path !== "/" && timer2 && live && (
          <div className={!live ? "none" : "time"}>
            <div className="ends"> Ends in &nbsp;</div>
            <span className="timer">
              <span>
                {" "}
                {timer2 &&
                  (timer2.days < 10
                    ? String(timer2.days).padStart(2, "0")
                    : timer2.days)}{" "}
                <sub className="unit">D</sub>
              </span>

              <span>
                {timer2 &&
                  (timer2.hours < 10
                    ? String(timer2.hours).padStart(2, "0")
                    : timer2.hours)}{" "}
                <sub className="unit">H</sub>
              </span>

              <span>
                {timer2 &&
                  (timer2.minutes < 10
                    ? String(timer2.minutes).padStart(2, "0")
                    : timer2.minutes)}
                <sub className="unit" style={{ marginLeft: "5px" }}>
                  M
                </sub>
              </span>
              <span>
                {timer2 &&
                  (timer2.seconds < 10
                    ? String(timer2.seconds).padStart(2, "0")
                    : timer2.seconds)}
                <sub className="unit" style={{ marginLeft: "5px" }}>
                  S
                </sub>
              </span>
            </span>
          </div>
        )}
        {props.match.path !== "/" && (
          <div className={`buyButton_div ${live && "margin"}`}>
            <div className="left" style={{ borderRight: !live && "none" }}>
              <div className={live ? "slider" : "none"}>
                <ModSlider
                  className="rollSlider"
                  marks={marks}
                  aria-labelledby="discrete-slider-always"
                  valueLabelDisplay="auto"
                  aria-label="pretto slider"
                  min={0.1}
                  max={10}
                  value={val}
                  step={0.01}
                  onChange={handleSliderChange}
                ></ModSlider>
              </div>
              {live && (
                <span style={{ fontSize: "12px", marginTop: "-10px" }}>
                  + 0.0004 BNB for gas fees
                </span>
              )}
              <Button
                style={{
                  textTransform: "none",
                  opacity: live && isDisabled() ? 0.5 : 1,
                }}
                variant="contained"
                className={live ? "buyButton" : "none"}
                disabled={isDisabled()}
                onClick={() => bnbTransfer()}
              >
                {txnLoading ? (
                  <CircularProgress
                    className="circle"
                    size="22px"
                    style={{ color: "black" }}
                  />
                ) : live && isDisabled() ? (
                  "Connect your wallet"
                ) : live ? (
                  "Participate"
                ) : (
                  "Learn More"
                )}
              </Button>
              <Button
                style={{
                  textTransform: "none",
                }}
                variant="contained"
                className={live ? "none" : "buyButton"}
                // disabled={isDisabled()}
                onClick={() => props.history.push("/sale")}
              >
                Learn More
              </Button>
              <div
                className="registerLine"
                style={{ width: "100%", margin: "2% auto" }}
              >
                Register for the <b>200 BNB </b>Airdrop{" "}
                <span>
                  <a
                    href="https://gleam.io/eHmZl/cefa-private-sale-harvest-round-giveaway"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      textDecoration: "underline",
                      color: "#fdcd0b",
                      fontSize: "1.1rem",
                    }}
                  >
                    here
                  </a>
                </span>
              </div>
              <div className="walletDetails">
                <i>Wallet ID</i> :{" "}
                <span style={{ color: "#fdcd0b" }}>
                  0x3e4a42F2CCC77CBF284C377079829C0c8047e64e
                </span>
              </div>
            </div>

            {live && (
              <div className="right">
                <ul>
                  <li>1 BNB = 2500 CEFA</li>
                  <li>Minimum buy - 0.1 BNB</li>
                  <li>Maximum buy - 10 BNB</li>
                  <li>
                    <b>BONUS</b> : 5% more tokens with 1 BNB+ investment
                  </li>
                  <li>
                    <b>BONUS</b> : 10% more tokens with 3 BNB+ investment
                  </li>
                  <li>
                    <b>BONUS</b> : 25% more tokens with 5 BNB+ investment
                  </li>
                  <li>
                    <b>BONUS</b> : 50% more tokens with 10 BNB max investment
                  </li>
                  <li>
                    You will receive CEFA tokens within 6 hours of the Private
                    Sale's end.
                  </li>
                  {/* <li>Unsold tokens will be BURNED</li> */}
                </ul>
              </div>
            )}
          </div>
        )}
        {props.match.path === "/" && (
          <Button
            style={{
              textTransform: "none",
            }}
            variant="contained"
            className={"buyButton"}
            // disabled={isDisabled()}
            onClick={() => props.history.push("/sale")}
          >
            Learn More
          </Button>
        )}
        <div className="downArrow" id="signupSection">
          <a href="#signupSection">
            <img src="/features/downArrow.png" alt="down" />
          </a>
        </div>
      </div>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={toastOpen}
        autoHideDuration={3000}
        onClose={handleClose}
        key="top-center"
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleClose}
          severity={statusCode === 200 ? "success" : "error"}
        >
          {statusCode === 200
            ? "Transaction Successful!"
            : "Some technical error occured."}
        </MuiAlert>
      </Snackbar>
    </FeaturesCss>
  );
};

export default Features;
